import React, { useState, useEffect, useContext } from 'react'
import './FullSchedule.css'
import './FullScheduleCards.css'
import { useParams, Link, NavLink } from 'react-router-dom'
import { AuthContext } from '../context/auth-context'
import Footer from '../components/UIElements/Footer'
//
import backstromBoys from '../../images/teamLogos/Backstrom boys.png'
import berserkers from '../../images/teamLogos/Berserkers 2.png'
import blackWidows from '../../images/teamLogos/Black Widows.png'
import bolts from '../../images/teamLogos/Bolts.jpg'
import bombers from '../../images/teamLogos/Bombers.png'
import bonnieNClyde from '../../images/teamLogos/Bonnie n clyde.jpg'
import capitalPunishment from '../../images/teamLogos/Capital punishment.png'
import chops from '../../images/teamLogos/Carolina chops.png'
import chernobyl from '../../images/teamLogos/Chernobyl.png'
import chimneyFish from '../../images/teamLogos/Chimney fish.png'
import dcCorruption from '../../images/teamLogos/Dc corruption.jpg'
import ehHoles from '../../images/teamLogos/Eh-holes.png'
import firstLadies from '../../images/teamLogos/First ladies.jpg'
import freeze from '../../images/teamLogos/Freeze.png'
import gjwthf from '../../images/teamLogos/GJWTHF.png'
import goldenGirls from '../../images/teamLogos/Golden girls.png'
import graffix from '../../images/teamLogos/Graffix.png'
import grenlockMonsters from '../../images/teamLogos/Grenlock monsters.png'
import heathens from '../../images/teamLogos/Heathens.png'
import hiredGuns from '../../images/teamLogos/Hired Guns.png'
import invaders from '../../images/teamLogos/Invaders.png'
import mallards from '../../images/teamLogos/Mallards.png'
import mooseKnuckles from '../../images/teamLogos/mooseKnuckles.png'
import redWolves from '../../images/teamLogos/redWolves.PNG'
import sassNSpades from '../../images/teamLogos/sassNSpades.PNG'
import midnightExpress from '../../images/teamLogos/Midnight express.png'
import misfits from '../../images/teamLogos/Misfits Coed.png'
import missConducts from '../../images/teamLogos/Miss conducts.jpg'
import nightswatchBlack from '../../images/teamLogos/Nightswatch Black.png'
import nightswatchWhite from '../../images/teamLogos/Nightswatch White.png'
import ninjaTurtles from '../../images/teamLogos/Ninja turtles.jpg'
import nukes from '../../images/teamLogos/Nukes.png'
import pigeons from '../../images/teamLogos/Ny pigeons.png'
import purplePower from '../../images/teamLogos/Purple power.png'
import roastMellows from '../../images/teamLogos/Roast mellows.png'
import rockies from '../../images/teamLogos/Rockies.png'
import ronin from '../../images/teamLogos/Ronin.png'
import saltyCrabsMensA from '../../images/teamLogos/Salty Crabs mens A.png'
import shortis from '../../images/teamLogos/Shortis Logo.PNG'
import sjCyclones from '../../images/teamLogos/SJ cyclones.png'
import sjEnforcers from '../../images/teamLogos/SJ enforcers.png'
import sjsharks from '../../images/teamLogos/SJ sharks.png'
import southBolts from '../../images/teamLogos/South bolts.jpg'
import southHillsBandits from '../../images/teamLogos/South Hills Bandit.png'
import southSiders from '../../images/teamLogos/South Siders.png'
import stallions from '../../images/teamLogos/Stallions.png'
import thugBunnies from '../../images/teamLogos/Thug bunnies.jpg'
import venom from '../../images/teamLogos/venom.png'
import caniseCarai from '../../images/teamLogos/Canise Carai.PNG'
import doggPound from '../../images/teamLogos/doggPound.png'
import ellasFellas from '../../images/teamLogos/ellasFellas.png'
import rabidRaccoons from '../../images/teamLogos/Rabid raccoons.png'
import stingrays from '../../images/teamLogos/stingrays.PNG'
import vengeance from '../../images/teamLogos/Vengeance.png'
import banksvilleBucks from '../../images/teamLogos/banksvilleBucks.PNG'
import mckeesportPaladins from '../../images/teamLogos/McKeesportPaladins.png'
import starhawks from '../../images/teamLogos/starhawks.PNG'
import bridgers from '../../images/teamLogos/bridgers.png'
import jhamericans from '../../images/teamLogos/JH_Americans.png'
import thrustfund from '../../images/teamLogos/ThrustFund.png'
import offsides from '../../images/teamLogos/offsides.PNG'

const FullSchedule = () => {
	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState()
	const [allGamesAndEvents, setAllGamesAndEvents] = useState([])
	const [currentTournaments, setCurrentTournaments] = useState()
	//
	const auth = useContext(AuthContext)

	console.log('inside FullSchedule')

	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/admin/allGamesAndEvents',
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setAllGamesAndEvents(responseData.allItems)
				setCurrentTournaments(responseData.currentTournaments)

				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [])
	//
	//
	const teamLogoMap = {
		'Backstrom Boys': backstromBoys,
		Berserkers: berserkers,
		'Black Widows': blackWidows,
		Bolts: bolts,
		Bombers: bombers,
		'Bonnie N Clyde': bonnieNClyde,
		'Capital Punishment': capitalPunishment,
		Chops: chops,
		Chernobyl: chernobyl,
		'Chimney Fish': chimneyFish,
		'DC Corruption': dcCorruption,
		'Eh-Holes': ehHoles,
		'First Ladies': firstLadies,
		Freeze: freeze,
		GJWTHF: gjwthf,
		'Golden Girls': goldenGirls,
		Graffix: graffix,
		'Grenlock Monsters': grenlockMonsters,
		Heathens: heathens,
		'Hired Guns': hiredGuns,
		Invaders: invaders,
		'Midnight Express': midnightExpress,
		Misfits: misfits,
		'Miss Conducts': missConducts,
		'Nights Watch Black': nightswatchBlack,
		'Nights Watch White': nightswatchWhite,
		'Ninja Turrles': ninjaTurtles,
		Nukes: nukes,
		Pigeons: pigeons,
		'Purple Power': purplePower,
		'Roast Mellows': roastMellows,
		Rockies: rockies,
		Ronin: ronin,
		'Salty Crabs': saltyCrabsMensA,
		Shortis: shortis,
		Cyclones: sjCyclones,
		Enforcers: sjEnforcers,
		Sharks: sjsharks,
		'South Bolts': southBolts,
		Bandits: southHillsBandits,
		'South Siders': southSiders,
		Stallions: stallions,
		'Thug Bunnies': thugBunnies,
		Venom: venom,
		'Chimney Fish': chimneyFish,
		'Nights Watch': nightswatchBlack,
		Mallards: mallards,
		'Sass N Spades': sassNSpades,
		'Raleigh Red Wolves': redWolves,
		'Moose Knuckles': mooseKnuckles,
		'Canise Carai-Pereira': caniseCarai,
		'Dogg Pound': doggPound,
		"Ella's Fellas": ellasFellas,
		'Rabid Raccoons': rabidRaccoons,
		Stingrays: stingrays,
		Vengeance: vengeance,
		'Banksville Bucks': banksvilleBucks,
		McKeesport: mckeesportPaladins,
		StarHawks: starhawks,
		Bridgers: bridgers,
		'JH Americans': jhamericans,
		'Thrust Fund': thrustfund,
		Offsides: offsides,
	}
	//
	//
	const formatGameDate = (game) => {
		const months = {
			'01': 'Jan.',
			'02': 'Feb.',
			'03': 'Mar.',
			'04': 'Apr.',
			'05': 'May',
			'06': 'June',
			'07': 'July',
			'08': 'Aug.',
			'09': 'Sept.',
			10: 'Oct.',
			11: 'Nov.',
			12: 'Dec.',
		}

		return `${game.dayOfWeek}, ${months[game.date.substr(0, 2)]} ${game.date.substr(3, 2)}`
	}

	const formatGameTime = (game) => {
		const hour = game.time.substr(0, 2)
		const minute = game.time.substr(3, 2)

		const times = {
			'00': `12:${minute} am`,
			'01': `1:${minute} am`,
			'02': `2:${minute} am`,
			'03': `3:${minute} am`,
			'04': `4:${minute} am`,
			'05': `5:${minute} am`,
			'06': `6:${minute} am`,
			'07': `7:${minute} am`,
			'08': `8:${minute} am`,
			'09': `9:${minute} am`,
			10: `10:${minute} am`,
			11: `11:${minute} am`,
			12: `12:${minute} pm`,
			13: `1:${minute} pm`,
			14: `2:${minute} pm`,
			15: `3:${minute} pm`,
			16: `4:${minute} pm`,
			17: `5:${minute} pm`,
			18: `6:${minute} pm`,
			19: `7:${minute} pm`,
			20: `8:${minute} pm`,
			21: `9:${minute} pm`,
			22: `10:${minute} pm`,
			23: `11:${minute} pm`,
			24: `12:${minute} am`,
		}

		return times[hour]
	}

	const getDivisionLabel = (game) => {
		return game.playoff ? game.playoffDivision : game.divisionName
	}

	const getDisplayScore = (game) => {
		if (!game.score) {
			return 'TBP'
		}

		return game.score
	}
	//
	//
	const errorHandler = () => {
		setError(null)
	}
	//
	//
	//
	let distinctVenues
	let distinctVenuesArray
	distinctVenuesArray = []

	if (allGamesAndEvents.length !== 0) {
		distinctVenues = [...new Set(allGamesAndEvents.map((x) => x.venueName))]
		for (let i = 0; i < distinctVenues.length; i++) {
			distinctVenuesArray.push(distinctVenues[i])
		}
	}

	let dateBlock
	dateBlock = []
	if (!isLoading && allGamesAndEvents.length === 0) {
		return (
			<React.Fragment>
				{/* <AdminNavigation /> */}
				<div className='Leagues'>
					<h1>NOTHING SCHEDULED YET!</h1>
				</div>
				<div style={{ marginTop: '16rem' }}>
					<Footer />
				</div>
			</React.Fragment>
		)
	}
	if (
		!isLoading &&
		allGamesAndEvents.length !== 0 &&
		currentTournaments.length !== 0 &&
		distinctVenuesArray
	) {
		distinctVenuesArray.forEach((venue) => {
			dateBlock.push(
				<div className='Schedule' style={{ marginTop: '1rem' }}>
					{/* <AdminNavigation /> */}
					<div className='scheduleVenueHeader'>
						<span>{venue}</span>
					</div>
					<table id='defaultScheduleDisplay'>
						<thead>
							<tr>
								<th>Date/Time</th>
								{/* <th>Time</th> */}
								{currentTournaments.length > 1 && <th>Tournament</th>}
								<th>Division</th>
								<th>Visitor/Home</th>
								<th></th>
								{auth.isLoggedIn && <th></th>}
								<th>Winner</th>
								<th>Score</th>
								{/* <th>Venue</th> */}
							</tr>
						</thead>
						<tbody>
							{allGamesAndEvents.map((game, key) => {
								if (game.venueName === venue) {
									return (
										<tr key={key}>
											<td>
												{game.dayOfWeek}
												{', '}
												{game.date.substr(0, 2) === '01' &&
													'Jan. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '02' &&
													'Feb. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '03' &&
													'Mar. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '04' &&
													'Apr. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '05' &&
													'May ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '06' &&
													'June ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '07' &&
													'July ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '08' &&
													'Aug. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '09' &&
													'Sept. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '10' &&
													'Oct. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '11' &&
													'Nov. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '12' &&
													'Dec. ' + game.date.substr(3, 2)}
												<br></br>
												{game.time.substr(0, 2) === '00' &&
													'12:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '01' &&
													'1:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '02' &&
													'2:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '03' &&
													'3:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '04' &&
													'4:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '05' &&
													'5:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '06' &&
													'6:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '07' &&
													'7:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '08' &&
													'8:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '09' &&
													'9:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '10' &&
													'10:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '11' &&
													'11:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '12' &&
													'12:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '13' &&
													'1:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '14' &&
													'2:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '15' &&
													'3:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '16' &&
													'4:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '17' &&
													'5:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '18' &&
													'6:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '19' &&
													'7:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '20' &&
													'8:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '21' &&
													'9:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '22' &&
													'10:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '23' &&
													'11:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '24' &&
													'12:' + game.time.substr(3, 2) + ' am'}
											</td>
											{currentTournaments.length > 1 && (
												<td>
													{(game.leagueName && game.leagueName) ||
														game.eventName}
												</td>
											)}
											{!game.playoff && <td>{game.divisionName}</td>}
											{game.playoff && <td>{game.playoffDivision}</td>}

											{game.visitorTeamName && (
												<td>
													{game.visitorTeamSeed > 0 &&
														'(' + game.visitorTeamSeed + ') '}
													{game.visitorTeamName && game.visitorTeamName}
													<br></br>
													{' @ '}
													<br></br>
													{game.homeTeamSeed > 0 &&
														'(' + game.homeTeamSeed + ') '}
													{game.homeTeamName && game.homeTeamName}
													{game.description && (
														<div style={{ color: 'red', fontWeight: 'bold' }}>
															{'('}
															{game.description}
															{')'}
														</div>
													)}
												</td>
											)}
											{game.eventName && (
												<td
													style={{
														fontWeight: 'bold',
														backgroundColor: 'pink',
													}}
												>
													{game.eventName}
												</td>
											)}
											{game.description && <td></td>}
											{!game.playoff && !game.championship && <td></td>}

											{game.championship && (
												<td style={{ color: 'red', fontWeight: 'bold' }}>
													CHAMPIONSHIP GAME
												</td>
											)}
											{auth.isLoggedIn && (
												<td>
													{game.playoff &&
														game.homeTeamName &&
														game.homeTeamName !== 'TBD' &&
														game.visitorTeamName !== 'TBD' && (
															<NavLink
																className='navlinks'
																to={`/admin/playoffGameResults2/${game._id}`}
																exact
															>
																Results
															</NavLink>
														)}
													{!game.playoff &&
														!game.championship &&
														game.homeTeamName &&
														game.homeTeamName !== 'TBD' &&
														game.visitorTeamName !== 'TBD' && (
															<NavLink
																className='navlinks'
																to={`/admin/gameResults2/${game._id}`}
																exact
															>
																Results
															</NavLink>
														)}
													{game.playoff &&
														!game.championship &&
														game.homeTeamName &&
														(game.homeTeamName === 'TBD' ||
															game.visitorTeamName === 'TBD') && (
															<NavLink
																className='navlinksEnterTeams'
																to={`/admin/updateGame/${game._id}`}
																exact
															>
																TEAMS
															</NavLink>
														)}
												</td>
											)}
											{game.homeTeamId && game.winner === game.homeTeamId && (
												<td>{game.homeTeamName}</td>
											)}
											{game.visitorTeamId &&
												game.winner === game.visitorTeamId && (
													<td>{game.visitorTeamName}</td>
												)}
											{game.status &&
												game.status !== 'TBP' &&
												game.winner !== game.homeTeamId &&
												game.winner !== game.visitorTeamId && <td>TIE</td>}
											{!game.score && <td></td>}
											<td>
												{game.score && (
													<Link
														style={{
															textDecoration: 'none',
															fontWeight: 600,
															color: 'black',
														}}
														to={`/gameSummary/${game._id}`}
													>
														{game.score}
														{game.status === 'SO' && ' (SO)'}
														{game.status === 'OT' && ' (OT)'}
													</Link>
												)}
											</td>
										</tr>
									)
								}
							})}
						</tbody>
					</table>
					<div className='scheduleCardsMobile'>
						{allGamesAndEvents.map((game, key) => {
							if (game.venueName !== venue) {
								return null
							}

							const visitorLogo = teamLogoMap[game.visitorTeamName]
							const homeLogo = teamLogoMap[game.homeTeamName]

							return (
								<div
									className={`scheduleCard ${
										game.playoff || game.championship || game.description
											? 'scheduleCardPlayoff'
											: ''
									}`}
									key={`mobile-${key}`}
								>
									<div className='scheduleCard__header'>
										<div>{formatGameDate(game)}</div>

										<div className='scheduleCard__divisionHeader'>
											<div>
												{game.playoff ? 'PLAYOFF' : getDivisionLabel(game)}
											</div>

											{game.playoff && game.description && (
												<span className='scheduleCard__headerDescription'>
													{game.playoffDivision} - {game.description}
												</span>
											)}

											{!game.playoff && game.description && (
												<span className='scheduleCard__headerDescription'>
													{game.description}
												</span>
											)}
										</div>

										<div>{formatGameTime(game)}</div>
									</div>

									<div className='scheduleCard__body'>
										<div className='scheduleCard__team'>
											{homeLogo && (
												<img src={homeLogo} alt={game.homeTeamName} />
											)}
											<span
												className={
													game.winner === game.homeTeamId
														? 'scheduleCard__winnerPill'
														: ''
												}
											>
												{game.homeTeamSeed > 0 && `(${game.homeTeamSeed}) `}
												{game.homeTeamName}
											</span>
										</div>

										<div className='scheduleCard__scoreBox'>
											{game.score ? (
												<Link
													to={`/gameSummary/${game._id}`}
													className='scheduleCard__score'
												>
													{getDisplayScore(game)}
												</Link>
											) : (
												<div className='scheduleCard__score'>TBP</div>
											)}

											{game.score && (
												<div className='scheduleCard__status'>
													{game.status === 'SO'
														? 'SO'
														: game.status === 'OT'
															? 'OT'
															: 'FINAL'}
												</div>
											)}
										</div>

										<div className='scheduleCard__team'>
											{visitorLogo && (
												<img src={visitorLogo} alt={game.visitorTeamName} />
											)}
											<span
												className={
													game.winner === game.visitorTeamId
														? 'scheduleCard__winnerPill'
														: ''
												}
											>
												{game.visitorTeamSeed > 0 &&
													`(${game.visitorTeamSeed}) `}
												{game.visitorTeamName}
											</span>
										</div>
									</div>

									<div className='scheduleCard__venue'>📍 {game.venueName}</div>

									{game.championship && (
										<div className='scheduleCard__description'>
											CHAMPIONSHIP GAME
										</div>
									)}

									{auth.isLoggedIn && (
										<div className='scheduleCard__admin'>
											{game.playoff &&
												game.homeTeamName &&
												game.homeTeamName !== 'TBD' &&
												game.visitorTeamName !== 'TBD' && (
													<NavLink
														className='navlinks'
														to={`/admin/playoffGameResults2/${game._id}`}
														exact
													>
														Results
													</NavLink>
												)}

											{!game.playoff &&
												!game.championship &&
												game.homeTeamName &&
												game.homeTeamName !== 'TBD' &&
												game.visitorTeamName !== 'TBD' && (
													<NavLink
														className='navlinks'
														to={`/admin/gameResults2/${game._id}`}
														exact
													>
														Results
													</NavLink>
												)}

											{game.playoff &&
												!game.championship &&
												game.homeTeamName &&
												(game.homeTeamName === 'TBD' ||
													game.visitorTeamName === 'TBD') && (
													<NavLink
														className='navlinksEnterTeams'
														to={`/admin/updateGame/${game._id}`}
														exact
													>
														TEAMS
													</NavLink>
												)}
										</div>
									)}
								</div>
							)
						})}
					</div>
				</div>,
			)
		})
	}

	return (
		<div style={{ overflowX: 'hidden' }}>
			<React.Fragment>
				{dateBlock && dateBlock}
				<Footer />
			</React.Fragment>
		</div>
	)
}

export default FullSchedule
